import React, { useContext } from 'react'
import ContentHeader from '@Components/ContentHeader'
import StatusSection from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/StatusSection'
import { OverclaimFilterCount } from '@Entities/overclaim/overclaim-status-count'
import OverclaimSearchHeaderDescription from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimSearchHeader/OverclaimSearchHeaderDescription'
import { StoresContext } from '@App/contexts'
interface OverclaimHeaderProps {
    statusCounts: OverclaimFilterCount | undefined
}

const OverclaimSearchHeader = (props: OverclaimHeaderProps) => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)
    const { statusCounts } = props
    const titleAddition = () => {
        switch (overclaimSearchBulkActionStore.activeBulkAction) {
            case 'RELINQUISHMENT':
                return ' - Bulk Relinquishment'
            case 'DOCUMENT_UPLOAD':
                return ' - Bulk Document Upload'
            case 'AMENDMENT_SELECTION':
            case 'AMENDMENT_EDIT':
                return ' - Bulk Share Amendment'
            default:
                return ''
        }
    }
    return (
        <ContentHeader
            title={'Overclaims Tool' + titleAddition()}
            descriptionElement={
                <OverclaimSearchHeaderDescription bulkActionType={overclaimSearchBulkActionStore.activeBulkAction} />
            }
        >
            {statusCounts && <StatusSection statusCounts={statusCounts} />}
        </ContentHeader>
    )
}
export default OverclaimSearchHeader
